import React from 'react';
import { Row, Col, Radio } from 'antd';

import RadioGroup from 'components/Fields/Radio';

export const UniqueControlList = ({ name, label: FieldLabel, items, required }) => (
  <Row gutter={16}>
    <RadioGroup
      model={`.${name}`}
      label={FieldLabel}
      type="radio"
      errorMessages={required ? { required: { message: 'Veuillez choisir une réponse' } } : undefined}
      options={items.map(item => ({ label: item, value: item }))}
      renderItem={({ value, label }) => (
        <Col
          key={`${name}${value}`}
          span={8}
        >
          <label style={{ marginRight: 10 }}>
            <Radio value={value} />
            {label}
          </label>
        </Col>
      )}
    />
  </Row>
);

export default UniqueControlList;



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlList/UniqueControlList.js